<template>
  <div class="space-top-desktop">
    <h1 style="text-align: center">Segurança</h1>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <p>
          As grades serrilhadas foram especialmente projetadas para uso em áreas de operação onde exista óleo, água ou outros líquidos, e que a segurança seja um fator importante
          prevenindo o escorregamento.
        </p>
        <img src="@/assets/images/img_grade10.jpg" alt="img" class="img-shadow-blue w-100  img-fluid" style="margin-top: 50px" />
      </b-col>
      <b-col sm="12" md="6">
        <img src="@/assets/images/petrolifera2.jpg" alt="img" class="img-shadow-blue w-100 img-fluid sec-img" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Seguranca",
};
</script>
